import { Link, useLocation } from 'react-router-dom';
import { categories, getCategoryBySlug } from '@/mocks/categories';

const getRouteLabel = (path: string): { label: string; href: string }[] => {
  const crumbs: { label: string; href: string }[] = [{ label: '首页', href: '/' }];

  if (path === '/') return crumbs;

  if (path.startsWith('/category/')) {
    const slug = path.split('/')[2];
    const cat = getCategoryBySlug(slug);
    if (cat) {
      crumbs.push({ label: cat.name, href: path });
    }
  }

  if (path.startsWith('/article/')) {
    crumbs.push({ label: '文章详情', href: path });
  }

  if (path === '/about') {
    crumbs.push({ label: '关于我们', href: '/about' });
  }

  return crumbs;
};

export default function Breadcrumb() {
  const location = useLocation();
  const crumbs = getRouteLabel(location.pathname);

  if (crumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center gap-2 text-sm flex-wrap">
        {crumbs.map((crumb, index) => (
          <li key={crumb.href} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {index === crumbs.length - 1 ? (
              <span className="text-foreground-950 font-medium">{crumb.label}</span>
            ) : (
              <Link
                to={crumb.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors"
              >
                {crumb.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}